<div class="alert-outbound" *ngIf="message">
  <div class="alert-wrapper">
    <div class="alert" [ngClass]="message.cssClass">{{message.text}}</div>
  </div>
</div>
